<template>
    <main class="page-main">
        <section class="section-content movies-section">

            <!-- Section content -->
            <div class="content-wrapper">
                <h1>{{page.title}}</h1>

                <!-- Section tabs -->
                <div class="section-tabs">
                    <!-- Если нет рубрик, то надо оставить контейнер 'section-tabs' и не вставлять в него список <ul> -->
                    <ul v-if="page && page.categories.length > 1" class="section-menu__list">
                        <li v-for="item in page.categories" :key="item.id">
                            <router-link :to="{ name: page.route, params: { category : item.props } }"
                                         role="button"
                                         :class="{active: category === item.props }">
                                {{item.title}}
                            </router-link>
                        </li>
                    </ul>
                </div>
                <!-- /Section tabs -->
                <!-- Section tab content 1 -->
                <transition name="slide" transition-mode="in-out">
                    <router-view :key="$route.params.category"></router-view>
                </transition>
                <!-- /Section tab content 1 -->

            </div>
            <!-- /Section content -->
        </section>
    </main>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        props:['category'],
        name: "MoviesPage",
        computed:{
            ...mapGetters({
                menu: 'getMenu',
                loading: 'getLoading',
            }),
            page () {
                if(this.menu && this.menu.length > 0) {
                    return this.menu[0]
                } else {
                    return false;
                }
            },
        },
        created(){
            if(this.category === undefined){
                this.$router.replace({ name : this.page.route, params:{ category : this.page.categories[0].props}})
            }
        },
    }
</script>

<style scoped>

</style>